module.exports = __webpack_public_path__ + "img/dedicate-server.f16e5db.svg";